<!--
* @description
* @fileName index.vue
* @author fulina
* @date 2025/11/24 13:57:09
!-->
<template>
  <div class="page-root">
    <div class="header">
      <div class="logo">
        <img src="@images/mobile/logo.png" />
      </div>
      <div class="right-btn">
        <div v-if="language == 'zh-CN'" class="language" title="切换英文" @click="changeLanguage('en-US')">
          <span>CN</span>
        </div>
        <div v-if="language == 'en-US'" class="language" title="切换中文" @click="changeLanguage('zh-CN')">
          <span>EN</span>
        </div>
        <img v-if="!showMenu" class="menu-btn" src="@images/mobile/menuBtn.png" @click="showMenu = true" />
        <van-icon v-else name="arrow" color="#fff" @click="showMenu = false" />
      </div>
    </div>
    <van-popup
      v-model="showMenu"
      position="right"
      :style="{ width: '48%', height: '100%', top: 'calc(50% + 5.7992vh)' }"
      :get-container="getContainer"
      class="popup"
    >
      <van-list>
        <div v-for="item in menuItems" :key="item.path" class="menu-group">
          <van-cell
            :title="item.title"
            :class="{ active: isMenuActive(item) }"
            :is-link="Boolean(item.children && item.children.length)"
            :arrow-direction="expandedMenu === item.path ? 'up' : 'down'"
            @click="onMenuItemClick(item)"
          />
          <div v-if="item.children && item.children.length" v-show="expandedMenu === item.path" class="submenu">
            <van-cell
              v-for="child in item.children"
              :key="child.path"
              :title="child.title"
              :class="{ active: $route.path === child.path }"
              class="submenu-cell"
              @click="navigate(child.path)"
            />
          </div>
        </div>
      </van-list>
    </van-popup>
    <div class="root"><router-view /></div>

    <div v-show="false" class="tabbar">
      <div
        v-for="item in menuItems"
        :key="item.path"
        class="nav-item"
        :style="{ 'font-size': language === 'en-US' ? '1.6333vw' : '2.5333vw' }"
        :class="{ active: $route.path === item.path }"
        @click="navigate(item.path)"
      >
        {{ item.title }}
      </div>
    </div>
    <div class="copyright">
      <div class="copyright-t">CopyRight 1995-{{ curYear }} {{ $t('companyName') }} {{ $t('copyright') }}</div>
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        style="color: inherit; cursor: pointer; text-decoration: none"
        >{{ $t('recordName') }}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      curYear: new Date().getFullYear(),
      showMenu: false,
      menuItems: [
        { title: this.$t('navigation.home'), path: '/' },
        { title: this.$t('navigation.productSystem'), path: '/product-system' },
        { title: this.$t('navigation.groupMembers'), path: '/group-members' },
        { title: this.$t('navigation.devHistory'), path: '/dev-history' },
        { title: this.$t('navigation.onlineMall'), path: '/online-mall' },
        {
          title: this.$t('navigation.enterpriseNews'),
          path: '/enterprise-news',
          children: [
            { title: this.$t('navigation.mediaReports'), path: '/enterprise-news' },
            //{ title: this.$t('navigation.historyMedia'), path: '/history-media' }
          ]
        },
        { title: this.$t('navigation.contactUs'), path: '/contact-us' }
      ],
      expandedMenu: ['/enterprise-news', '/history-media'].includes(this.$route.path) ? '/enterprise-news' : '',
      language: localStorage.getItem('Language')
    }
  },

  computed: {},

  created() {},

  mounted() {},

  methods: {
    isMenuActive(item) {
      return (
        this.$route.path === item.path ||
        (item.children && item.children.some((child) => child.path === this.$route.path))
      )
    },
    onMenuItemClick(item) {
      if (item.children && item.children.length) {
        this.expandedMenu = this.expandedMenu === item.path ? '' : item.path
        return
      }
      this.navigate(item.path)
    },
    navigate(path) {
      this.$router.push(path)
      this.showMenu = false
    },
    getContainer() {
      return document.querySelector('.root')
    },
    changeLanguage(value) {
      this.$i18n.locale = value
      localStorage.setItem('Language', value)
      window.location.reload()
    }
  }
}
</script>
<style scoped lang='scss'>
.page-root {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .header {
    height: 5.7992vh;
    background: #b14b4b;
    display: flex;
    padding: 0 4.8vw;
    align-items: center;
    justify-content: space-between;
    background: url('~@images/mobile/bg/header-bg.jpg') no-repeat;
    background-size: 100% 100%;
    .logo {
      width: 25vw;
      img {
        width: 100%;
      }
    }
    .right-btn {
      display: flex;
      align-items: center;
      .language {
        cursor: pointer;
        width: 6.6234vw;
        height: 6.6234vw;
        border-radius: 50%;
        border: 1px solid #ffffff;
        text-align: center;
        line-height: 6.6234vw;
        color: #fff;
        font-size: 2.5333vw;
        margin-right: 4.3vw;
      }
      .menu-btn {
        width: 5.3333vw;
      }
      .van-icon-arrow {
        font-size: 5.3333vw;
      }
    }
  }
  .root {
    flex: 1;
    // height: calc(100vh - 5.7992vh - 5.6577vh - 4.6676vh);
    /deep/ .van-overlay {
      top: 5.7992vh;
    }
    overflow-y: auto;
  }
  .popup {
    .van-list {
      .menu-group {
        border-bottom: 1px solid #f4f4f4;
      }
      .van-cell {
        padding: 2.5289vh 4.8vw;
        font-size: 4vw;
        .van-icon {
          font-size: 3.3333vw;
        }
        &.active {
          font-weight: bold;
          color: #d70c18;
        }
      }
      .submenu {
        background-color: #fafafa;
      }
      .submenu-cell {
        padding-left: 9.6vw;
        font-size: 3.4667vw;
        background-color: transparent;
      }
    }
  }
  .tabbar {
    display: none;
    height: 5.6577vh;
    background: linear-gradient(180deg, #c91c1d 0%, #9f1a1d 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    .nav-item {
      color: #fff;
      padding: 0 2vw;
      font-size: 2.3333vw;
      line-height: 1;
      position: relative;
      &:not(:last-child)::after {
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 1px;
        height: 2.3333vw;
        background-color: #fff;
      }
      &.active {
        font-weight: bold;
        color: #ebc507;
      }
    }
  }
  .copyright {
    height: 4.6676vh;
    // background: #8c1d22;
    // border: 1px solid #8c1d22;
    background: linear-gradient(180deg, #c91c1d 0%, #9f1a1d 100%);
    color: #fff;
    font-size: 1.8vw;
    line-height: 1.473vh;
    text-align: center;
    .copyright-t {
      margin-top: 1.2144vh;
    }
  }
}
</style>
